module.exports = __webpack_public_path__ + "img/Group 2.4a54ac7c.png";